/**
 * 2020/4/23 by Ariel
 * 章节中固定题目批量导入
 判断逻辑：
 1、判断题目编码是否存在，若不存在进行提示
 注：若编码题目是删除状态的，也是不允许导入的，同提示编码不存在
 2、判断题目编码所属题库是否符合登录账号管理权限，若不符合进行提示
 3、若继续导入，则导入正常数据，异常数据不做导入
 */
import React from "react";
import {connect} from 'dva';
import {framework_tool, component_tool} from '../../../../tool'
import 'antd/dist/antd.css';
import {modelUtils} from "../../../../utils";

let {WizContainer} = framework_tool;
import {ExportExcel} from '@/components/index'

let {WizSpin, WizTypography, WizModal} = component_tool;
const {Paragraph} = WizTypography;

class ExamQuestionImport extends WizContainer {

  componentName = 'examQuestionImport';

  constructor(props) {
    super(props);
    this.state = {}
    this.chapterInfos = []
  }

  _handleImport(nextProps, nextState) {
    let o = nextProps['QuestionImport']
    if (o['success']) {
      let data = o['data'];
      let str = data['import'].toString().replace(/<br\/>/g, "\n")
      let info =data['chapterInfos']
      this.chapterInfos = info;
      if (this.props.callback) {
        this.props.callback(this.chapterInfos)
      }
      WizModal.success({
        title: '导入结果',
        content: <p style={{whiteSpace: "pre-line"}}>{str}</p>
      })
      return true;
    } else {
      wizNotice.error("导入数据出错，请联系相关人员")
      return false;
    }
  }

  propsAndStateOnChange = {
    QuestionImport: this._handleImport.bind(this),
  }


  _render() {
    let examId = this.props.examId;
    let infoProps = {
      title: '导入说明',
      text: [
        <Paragraph>1、从模版链接中下载模版文件</Paragraph>,
        <Paragraph>2、按照要求格式填写信息</Paragraph>,
        <Paragraph>3、当完成Excel文件的填写后，点击“上传文件”按钮上传此文件</Paragraph>,
      ]
    }
    let operateProps = {
      title: '固定题目批量导入',
      template: {
        label: '模版下载',
        fileName: '模版.xlsx',
        href: constants.files.excel_examQuestion,
      }

    }
    let submit = (file, fileData) => {
      let apiPath = 'exam/importExamQuestion';
      this.doAction({
        path: apiPath,
        payload: {
          key: "importExamQuestion",
          apiParams: {
            fileData,
            "examId": examId
          }
        }
      });
    }
    let {examLoading} = this.props;
    return (
      <WizSpin tip={'文件上传中'} spinning={examLoading}>
        <ExportExcel
          infoProps={infoProps}
          operateProps={operateProps}
          submit={submit}
        />
      </WizSpin>
    );
  }
}


const mapStateToProps = (state, ownProps) => {
  const {exam} = state;
  const QuestionImport = modelUtils.getModelEntity(exam, 'importExamQuestion');
  //获取loading的方式
  const load = modelUtils.getLoadingState(state, 'exam')
  return {
    QuestionImport: QuestionImport,
    ...load
  }
};

export default connect(mapStateToProps)(ExamQuestionImport);
